import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TherapistSignUpFooter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignInClick = () => {
    navigate("/signInTherapist");
  };

  return (
    <>
      {/* <div className="flex items-center my-4">
        <hr className="flex-grow border-text" />
        <span className="mx-4 text-text text-[15px] font-poppins">{t("or")}</span>
        <hr className="flex-grow border-text" />
      </div> */}

      {/* <div className="flex justify-center space-x-[48px]">
        <div className="relative">
          <img 
            src={GoogleIcon} 
            alt="Google" 
            className={`w-[55px] h-[55px] cursor-pointer transition-opacity ${
              oauthProvider === 'google' ? 'opacity-50' : 'hover:opacity-80'
            }`}
            onClick={() => handleOAuthSignUp('google')}
          />
          {oauthProvider === 'google' && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
        </div>
        
        <div className="relative">
          <img
            src={FacebookIcon}
            alt="Facebook"
            className={`w-[55px] h-[55px] cursor-pointer transition-opacity ${
              oauthProvider === 'facebook' ? 'opacity-50' : 'hover:opacity-80'
            }`}
            onClick={() => handleOAuthSignUp('facebook')}
          />
          {oauthProvider === 'facebook' && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
            </div>
          )}
        </div>
      </div> */}

      <div className="flex items-center my-4">
        <hr className="flex-grow border-text" />
        <hr className="flex-grow border-text" />
      </div>

      <p className="text-center text-[15px] text-text mt-6 font-poppins">
        {t("signInQuestion")}{" "}
        <span
          className="ml-6 font-poppins font-[700] text-text cursor-pointer"
          onClick={handleSignInClick}
        >
          {t("signIn")}
        </span>
      </p>
    </>
  );
};

export default TherapistSignUpFooter;
